import {
  Accordion,
  AccordionDetails,
  AccordionProps,
  AccordionSummary,
  AccordionSummaryProps,
  styled
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { StyledTextOrTranslation, TextOrTranslationProps } from '.'

const AccordionBorderless = styled((props: AccordionProps) => (
  <Accordion {...props} />
))(({ theme }) => ({
  margin: 'unset',
  boxShadow: 'none',
  width: '100%',
  [theme.breakpoints.up('md')]: {
    marginLeft: 0
  },
  '&:before': {
    backgroundColor: theme.variables.colors.accordionBorderless.backgroundColor
  },
  '&.Mui-expanded': {
    margin: 0
  }
}))

const AccordionSummaryIconLeft = styled((props: AccordionSummaryProps) => (
  <AccordionSummary {...props} />
))(({ theme }) => ({
  color: theme.variables.colors.accordionSummary.root,
  fontSize: theme.variables.fontSizes.accordionSummary.root,
  flexDirection: 'row-reverse',
  padding: 0,
  '& .MuiAccordionSummary-expandIconWrapper': {
    color: theme.variables.colors.accordionSummary.root,
    fontWeight: '600',
    transform: 'rotate(-90deg)'
  },
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(0deg)'
  },
  '& .MuiAccordionSummary-content': {
    marginLeft: theme.spacing(1)
  }
}))

const AccordionDetailsStyled = styled(AccordionDetails)(() => ({
  padding: 0
}))

interface BorderlessAccordionProps
  extends Pick<AccordionProps, 'children' | 'defaultExpanded'> {
  title?: TextOrTranslationProps['text']
  titleTranslationId?: TextOrTranslationProps['translationId']
}

export const BorderlessAccordion = ({
  children,
  defaultExpanded,
  title,
  titleTranslationId
}: BorderlessAccordionProps) => {
  return (
    <AccordionBorderless defaultExpanded={!!defaultExpanded}>
      <AccordionSummaryIconLeft expandIcon={<ExpandMoreIcon />}>
        <StyledTextOrTranslation
          text={title}
          translationId={titleTranslationId}
          typographyProps={{ fontWeight: '600' }}
        />
      </AccordionSummaryIconLeft>
      <AccordionDetailsStyled>{children}</AccordionDetailsStyled>
    </AccordionBorderless>
  )
}
